'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        height: "100%",
        "& $focusHighlight": {
            opacity: 0,
        },
        "&:hover": {
            boxShadow: "none",
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
            "& $focusHighlight": {
                opacity: 0,
            },
        },
        "&:active": {
            backgroundColor: variables.COLORS.GREYSCALE_95,
            boxShadow: "none",
        },
        "&$focusVisible": {
            borderRadius: variables.SIZES.BORDER_RADIUS,
            boxShadow: `inset 0 0 0 2px ${variables.COLORS.MISC_FOCUS_BORDER}`,
            "& $focusHighlight": {
                opacity: 0,
            },
        },
    },
};

var MuiCardActionArea = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiCardActionArea = MuiCardActionArea;
exports.light = light;
